import { DataSource } from '@angular/cdk/table';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { AttachmentService } from './attachment.service';
import { PaginationAttachmentResponse, Attachment } from '../models/attachment';

export class AttachmentDataSource implements DataSource<Attachment>{
 
    private attachmentSubject = new BehaviorSubject<Attachment[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private countSubject = new BehaviorSubject<number>(0);
    public counter$ = this.countSubject.asObservable();
    public loader$ = this.loadingSubject.asObservable();
    constructor(private attachmentService: AttachmentService) { }

    connect(collectionViewer: CollectionViewer): Observable<Attachment[]> {
        return this.attachmentSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.attachmentSubject.complete();
        this.loadingSubject.complete();
        this.countSubject.complete();
    }
    loadAttachmentList(jsonReq:any) {
        this.loadingSubject.next(true);
        this.attachmentService.getAttachmentList(jsonReq)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((result: PaginationAttachmentResponse) => {
                this.attachmentSubject.next(result.dataList);
                //
                this.countSubject.next(result.totalCount);
            });
    }
}